<ng-template #changedTooltip>{{ 'shared:comparisons.changed' | i18next: { date: comparisonData.changedOn | dateFormat: 'date',
        value: comparisonData.initialValue, interpolation: i18NextInterpolationOptions } }}</ng-template>

<ng-template #addedTooltip>{{ 'shared:comparisons.added' | i18next: { date: comparisonData.changedOn | dateFormat: 'date',
    interpolation: i18NextInterpolationOptions} }}</ng-template>

<ng-template #removedTooltip>{{ 'shared:comparisons.removed' | i18next: { date: comparisonData.changedOn | dateFormat: 'date',
    interpolation: i18NextInterpolationOptions} }}</ng-template>

<ng-container [ngSwitch]="comparisonData?.status">
    <span *ngSwitchCase="'Changed'" class="s7-form-group-action">
        <span class="s7-form-group-icon s7-form-group-icon-popover" placement="top" [ngbTooltip]="changedTooltip">
        </span>
    </span>
    <span *ngSwitchCase="'Added'" class="s7-form-group-action">
        <span class="s7-form-group-icon s7-form-group-icon-popover" placement="top" [ngbTooltip]="addedTooltip">
        </span>
    </span>
    <span *ngSwitchCase="'Removed'" class="s7-form-group-action">
        <span class="s7-form-group-icon s7-form-group-icon-popover" placement="top" [ngbTooltip]="removedTooltip">
        </span>
    </span>
</ng-container>
